import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect } from "react";
import Page from "../../../components/layouts/Page";
import '../../../css/views/public/Entorn.css';
import image from '../../../assets/img/entorn.jpg';
import roures from '../../../assets/img/roures.jpeg';
import estela from '../../../assets/img/estela.jpg';
import roc from '../../../assets/img/roc.jpg';
import rasos from '../../../assets/img/rasos.jpeg';
import figuerassa from '../../../assets/img/figuerassa.webp';
import berga from '../../../assets/img/berga.jpeg';
import queralt from '../../../assets/img/queralt.jpeg';
import bici from '../../../assets/img/bici.jpg';
import Footer from "../../../layouts/public/Footer";
import SectionEdit from "./PlaceEdit";

import useScrollPosition from "../../../components/elements/useScrollPosition";
import ScrollToTop from "react-scroll-to-top";
import Edit from "../Edit";
import ButtonAdmin from "../ButtonAdmin";
import DeleteIcon from '@mui/icons-material/Delete';

function PlaceEdit(props) {
    const [open, setOpen] = useState(true);
    const [animation, setAnimation] = useState('');
    const [title, setTitle] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
		setTimeout(() => {
			setAnimation('Portada-expand');
		}, 500);
        setTimeout(() => {

            setTitle('title-expand');
		}, 500);
        
    }, []);

    const scrollPosition = useScrollPosition();

    useEffect(() => {
        let elementsToShowLeft = document.querySelectorAll(".show-on-scroll-left");
        elementsToShowLeft.forEach((element, index) => {
            if (element.getBoundingClientRect().top <= window.innerHeight-(window.innerHeight/2)) {
                element.classList.add('showOnScrollLeft');
            }
        })
        let elementsToShowRight = document.querySelectorAll(".show-on-scroll-right");
        elementsToShowRight.forEach((element, index) => {
            if (element.getBoundingClientRect().top <= window.innerHeight-(window.innerHeight/2)) {
                element.classList.add('showOnScrollRight');
            }
        })
        
    }, [scrollPosition]);
    
    function onClickEliminarEntorn () {

    }
	
    // const url = 'http://127.0.0.1:8000/storage/';
    const url = 'https://api.masiaelpinatell.com/public/storage/';

    if (props.isLeft) {
        return (
            <Box className='Entorn-section' sx={{maxWidth: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: 'unset', paddingRight: 'unset'}}>
                <div style={{position: 'relative', top: '0', left: '0', background:'white', padding: '0.5rem 0rem 0.5rem 0.5rem', display: 'flex', justifyContent:'center', alignItems:'center', borderRadius: '0.4rem'}}>
                    <ButtonAdmin 
                        text={''} 
                        icon={<DeleteIcon />} 
                        variant='' 
                        action={() => {onClickEliminarEntorn(props.data.id)}} 
                        setOpenDeleteModal={props.setOpenDeleteModal}
                        endPoint={'eliminarEntorn'}
                        setEndPoint={props.setEndPoint}
                        id={props.data.id}
                        setId={props.setId}
                        folder={'Entorn'}
                        setFolder={props.setFolder}
                    />
                </div>
                <div className="Entorn-section-left show-on-scroll-left">
                    <div style={{position: 'absolute', top: '5%', left: '5%'}}>
                        <Edit endPoint='actualitzarEntorn' initialValue={props.data?.imatge} setInitialValue={props.setInitialValue} name={'imatge'} setName={props.setName} setEndPoint={props.setEndPoint} color='#fff' setOpenModal={props.setOpenModal} type={'image'} setType={props.setType} label='Imatge' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'entorn'} setFolder={props.setFolder}/>
                    </div>
                    <img src={url+props.data?.imatge} className='Entorn-img'/>
                </div>
                <div className="Entorn-section-right show-on-scroll-right">
                    <div style={{display: 'flex'}}>
                        <Typography variant='h2' className="Entorn-title" textTransform='capitalize' color={'#1D1D1B'} fontWeight='800'>{props.data?.titol}</Typography>
                        <Edit endPoint='actualitzarEntorn' initialValue={props.data?.titol} setInitialValue={props.setInitialValue} name={'titol'} setName={props.setName} setEndPoint={props.setEndPoint} color='#1D1D1B' setOpenModal={props.setOpenModal} type={'link'} setType={props.setType} label='Títol' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'espai'} setFolder={props.setFolder}/>
                    </div>
                    <div className="Entorn-separator"></div>
                    <Edit endPoint='actualitzarEntorn' initialValue={props.data?.text} setInitialValue={props.setInitialValue} name={'text'} setName={props.setName} setEndPoint={props.setEndPoint} color='#333' setOpenModal={props.setOpenModal} type={'text'} setType={props.setType} label='Imatge' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'entorn'} setFolder={props.setFolder}/>
                    <Typography dangerouslySetInnerHTML={{__html: props.data?.text}} variant='body1' className='Entorn-text' marginBottom='30px'></Typography>
                    
                </div>
            </Box>
        )
    } else {
        return (
            <Box className='Entorn-section' sx={{maxWidth: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', paddingLeft: 'unset', paddingRight: 'unset'}}>
                <div style={{position: 'relative', top: '0', left: '0', background:'white', padding: '0.5rem 0rem 0.5rem 0.5rem', display: 'flex', justifyContent:'center', alignItems:'center', borderRadius: '0.4rem'}}>
                    <ButtonAdmin 
                        text={''} 
                        icon={<DeleteIcon />} 
                        variant='' 
                        action={() => {onClickEliminarEntorn(props.data.id)}} 
                        setOpenDeleteModal={props.setOpenDeleteModal}
                        endPoint={'eliminarEntorn'}
                        setEndPoint={props.setEndPoint}
                        id={props.data.id}
                        setId={props.setId}
                        folder={'Entorn'}
                        setFolder={props.setFolder}
                    />
                </div>
                <div className="Entorn-section-left show-on-scroll-left" style={{textAlign: 'right', display: 'flex', flexDirection: 'column', alignItems: 'flex-end'}}>
                    <div style={{display: 'flex'}}>
                        <Typography variant='h2' className="Entorn-title" textTransform='capitalize' color={'#1D1D1B'} fontWeight='800'>{props.data?.titol}</Typography>
                        <Edit endPoint='actualitzarEntorn' initialValue={props.data?.titol} setInitialValue={props.setInitialValue} name={'titol'} setName={props.setName} setEndPoint={props.setEndPoint} color='#1D1D1B' setOpenModal={props.setOpenModal} type={'link'} setType={props.setType} label='Títol' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'espai'} setFolder={props.setFolder}/>
                    </div>                    
                    <div className="Entorn-separator"></div>
                    <Edit endPoint='actualitzarEntorn' initialValue={props.data?.text} setInitialValue={props.setInitialValue} name={'text'} setName={props.setName} setEndPoint={props.setEndPoint} color='#333' setOpenModal={props.setOpenModal} type={'text'} setType={props.setType} label='Imatge' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'entorn'} setFolder={props.setFolder}/>
                    <Typography dangerouslySetInnerHTML={{__html: props.data?.text}} variant='body1' className='Entorn-text' marginBottom='30px'></Typography>
                    
                </div>
                <div className="Entorn-section-right show-on-scroll-right" style={{position: 'relative'}}>
                    <div style={{position: 'absolute', top: '5%', right: '5%'}}>
                        <Edit endPoint='actualitzarEntorn' initialValue={props.data?.imatge} setInitialValue={props.setInitialValue} name={'imatge'} setName={props.setName} setEndPoint={props.setEndPoint} color='#fff' setOpenModal={props.setOpenModal} type={'image'} setType={props.setType} label='Imatge' setLabel={props.setLabel} id={props.data?.id} setId={props.setId} folder={'entorn'} setFolder={props.setFolder}/>
                    </div>
                    <img src={url+props.data?.imatge} className='Entorn-img'/>
                    <Typography variant='h2' className="Entorn-title " textTransform='capitalize' color='#1D1D1B' fontWeight='800' style={{position: 'absolute', top: '10%', right: '40%'}}></Typography>
                </div>
            </Box> 
	    );
    }
	
}

export default PlaceEdit;
